export enum NotificationV2Constants {
    Subject= 'oh-sns-v2'
}
